// Bereinigte Version ohne "Active Integrations"
import React, { Component } from 'react'
import withStyles from '../../withStylesAdapter';
import classNames from 'classnames';
import withRouter from 'with-router'
import { connect } from 'react-redux'
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { withTranslation } from 'react-i18next';
import PartnerIntegrationsSettings from '../../components/PartnerIntegrations'
import LoadingIndicator from '../../components/LoadingIndicator'
import API from '../../api/api';

let categories = {
  'search': 'Search Apps',
  'review': 'Review Apps',
  'bundle': 'Bundle Apps',
  'pagebuilder': 'Page Builder',
  'seo': 'SEO & Tools',
  'mobile': 'Mobile Apps',
}

class RecommendedApps extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: '',
      partners: [],
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    API.partnerGetAll((res) => {
      if(res.success === true) {
        this.setState({
          loading: false,
          partners: res.partners
        });
      } else {
        this.setState({
          loading: false,
          error: res.error
        });
      }
    })
  }

  handleChange = (event) => {
    this.setState({
      category: event.target.value
    })
  }

  _getCategoryIdByLabel = (label) => {
    var found = Object.keys(categories).filter(function(key) {
      return categories[key] === label ? key : null;
    });
    if (found.length) {
       return found[0];
    }
  }

  orderByCat = (partners) => {
    return partners.sort((a, b) => {
      const categoryA = (a.category || '').toLowerCase();
      const categoryB = (b.category || '').toLowerCase();
  
      if (categoryA < categoryB) return -1;
      if (categoryA > categoryB) return 1;
      return 0;
    }); 
  }

  linkToListing = (item, children) => {
    if(!item.storeLink) return children;
    return (
      <a href={item.storeLink} target="_blank" rel="noopener noreferrer" title={this.props.t('partnerIntegrations.openListingTitle')} style={{ display: 'block', cursor: 'pointer' }}>
        {children}
      </a>
    );
  }

  renderPartnerCard = (item, index, divider) => {
    const { classes, t } = this.props;

    return <React.Fragment key={`fragment-${item.slug}`}>
      {divider}
      <Card key={`card-${item.title}`} className={classes.cardRoot}>
        {/* the banner links to the listing like on the integrations page; the buttons stay */}
        {this.linkToListing(item,
          <div className={classes.banner}>
            <div className={classes.media}>
              <img src={`/files/images/recommendedApps/${item.logo.replace('.jpg', '_b.jpg')}`} alt={item.title} />
              <div className={classes.diffusor}></div>
            </div>
            <span
              className={classes.mediaLogo}
              style={{ backgroundImage: `url(/files/images/recommendedApps/${item.logo})` }}
            />
          </div>
        )}
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="h5" component="h4" align="center">
            {item.title}
          </Typography>
          {item.subtitle &&
            <Typography gutterBottom variant="caption" component="p" align="center" style={{ marginBottom: 12 }}>
              {item.link ?
                <a href={item.link} target="_blank" className={classes.companyLink}>
                  <Chip label={item.subtitle} size="small" variant="outlined" style={{ cursor: 'pointer' }} />
                </a>
                :
                <Chip label={item.subtitle} size="small" variant="outlined" />
              }
              <br />
            </Typography>
          }
          <Typography variant="body2" color="text.secondary" component="p">
            {item.description}
          </Typography>
        </CardContent>
        {item.partnerIntegration.modules &&
          <PartnerIntegrationsSettings
            partnerHandle={item.slug}
            partnerData={item}
            activeIntegration={null}
            partnerIntegration={item.partnerIntegration.integration}
          />
        }
        <CardActions className={classes.cardActions}>
          {item.docsLink &&
            <Button size="small" color="primary" href={item.docsLink} target="_blank">
              {t('partnerIntegrations.documentationBtn')}
            </Button>
          }
          {item.storeLink &&
            <Button size="small" color="primary" variant="contained" href={item.storeLink} target="_blank">
              {t('partnerIntegrations.getAppBtn')}
            </Button>
          }
        </CardActions>
      </Card>
    </React.Fragment>
  }

  render() {
    const { classes, t } = this.props;
    const { category, partners } = this.state;
    let lastCategory = '';

    return (
      <React.Fragment>
        <LoadingIndicator pending={this.state.loading} />
        <Typography variant="h4" gutterBottom component="h2">
          {t('partnerIntegrations.recommendedApps')}
          <FormControl variant="outlined" margin="none" className={classNames(classes.formControl)}>
            <Select
              variant="outlined"
              id="category-select"
              value={category}
              onChange={this.handleChange}
              margin="none"
              size="small"
              displayEmpty>
              <MenuItem value=""><em>{t('partnerIntegrations.selectCategory')}</em></MenuItem>
              {Object.entries(categories).map(([key, value]) => (
                <MenuItem value={key} key={key}>
                  {category === key && <span className="selected-label">{t('partnerIntegrations.category')}</span>}
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Typography>
        <Divider className="divider-white" />
        <div className={classes.root}>
          <Grid container direction="row" justifyContent="start" alignItems="stretch" spacing={0} className={classes.gridRoot}>
            {this.orderByCat(partners).map((item, index) => {
              let divider = null;
              if (lastCategory !== item.category) {
                lastCategory = item.category;
                divider = <Grid size={12} style={{ padding: 0, margin: '0 20px' }} key={`divider-${item.category}`}>
                  <h3>{item.category}</h3>
                  <Divider />
                </Grid>
              }

              return (this._getCategoryIdByLabel(item.category) === category || category === '') &&
                this.renderPartnerCard(item, index, divider)
            })}
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shop }) => ({
  editLanguage: shop.shop.edit_language
})

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 20,
    overflow: 'hidden',
    padding: 24,
  },
  gridRoot: {
    justifyContent: 'start',
  },
  cardRoot: {
    // dark mode: paper is darker than the ground since 661c3cc, an outline keeps the card visible
    ...(theme.palette.mode === 'dark' ? { border: `1px solid ${theme.palette.divider}` } : {}),
    maxWidth: 325,
    width: 325,
    margin: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    position: 'relative'
  },
  banner: {
    position: 'relative',
  },
  media: {
    height: 120,
    opacity: 1,
    borderBottom: 'solid 1px #eeeeee',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      filter: 'contrast(200%) grayscale(50%) blur(4px) opacity(0.75)'
    }
  },
  mediaLogo: {
    width: 75,
    height: 75,
    position: 'absolute',
    display: 'inline-block',
    top: 60,
    left: 16,
    boxShadow: '2px -2px 10px 0px rgba(0,0,0,0.35)',
    border: 'solid 4px #fff',
    backgroundSize: 'contain'
  },
  cardContent: {
    height: '100%',
    marginTop: 10,
  },
  cardActions: {
    justifyContent: 'end',
  },
  diffusor: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,.25)'
  },
  companyLink: {
    color: theme.palette.accentMuted,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  formControl: {
    float: 'right',
    marginTop: -4,
    color: 'white',
    '& .MuiOutlinedInput-input': {
      padding: '12px 32px 12px 20px',
      color: 'white'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.23)',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, .5) !important',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, .23) !important',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.54) !important',
    }
  }
})

export default withRouter(connect(
  mapStateToProps,
  null,
)(withStyles(styles)(withTranslation()(RecommendedApps))))
